.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:host {
  background: #ffffff;
  display: block;
}

.asset-bar-and-related-products-wrapper {
  display: block;
  margin: 0 auto;
  padding: 0 16px 20px;
  box-sizing: border-box;
  max-width: 1200px;
  overflow: visible;
  color: #626469;
}

.asset-bar-and-related-products-wrapper *,
.asset-bar-and-related-products-wrapper *::before,
.asset-bar-and-related-products-wrapper *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .asset-bar-and-related-products-wrapper {
    padding: 0 10px;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-and-related-products-wrapper {
    padding-bottom: 48px;
  }
}

@media screen and (max-width: 979px) {
  .asset-bar-and-related-products-wrapper {
    padding: 20px 0;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-and-related-products {
    display: flex;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-and-related-products__column {
    padding-top: 48px;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-and-related-products__column--asset-bar {
    flex: 0 1 280px;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-and-related-products__column--related-products {
    flex: 1;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-and-related-products__column--asset-bar:only-child, .asset-bar-and-related-products__column--related-products:only-child {
    flex: 1 0 100%;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-and-related-products__column--half-width {
    flex: 0 1 50%;
  }
}

@media screen and (max-width: 979px) {
  .asset-bar-and-related-products__column--asset-bar + .asset-bar-and-related-products__column--related-products {
    margin-top: 36px;
  }
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .asset-bar-and-related-products__column--asset-bar + .asset-bar-and-related-products__column--related-products {
    margin-left: 56px;
  }

  :host([dir="rtl"]) .asset-bar-and-related-products__column--asset-bar + .asset-bar-and-related-products__column--related-products {
    margin-right: 56px;
  }
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .asset-bar-and-related-products__column--asset-bar.asset-bar-and-related-products__column--half-width + .asset-bar-and-related-products__column--related-products.asset-bar-and-related-products__column--half-width {
    margin-left: 20px;
  }

  :host([dir="rtl"]) .asset-bar-and-related-products__column--asset-bar.asset-bar-and-related-products__column--half-width + .asset-bar-and-related-products__column--related-products.asset-bar-and-related-products__column--half-width {
    margin-right: 20px;
  }
}

.asset-bar-and-related-products__column-header {
  color: #3dcd58;
}

@media screen and (max-width: 979px) {
  .asset-bar-and-related-products__column-header {
    font-size: 1rem;
    line-height: 1.5625rem;
    margin: 0 0 20px;
    padding: 0 16px;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-and-related-products__column-header {
    font-size: 1.75rem;
    line-height: 1.875rem;
    margin: 0 0 25px;
  }
}